<template>
  <div class="min-h-screen bg-[#F8F3ED]">
    <div class="mx-auto max-w-10xl px-4 py-10 lg:px-8">
      <div class="grid gap-6 lg:grid-cols-[260px_1fr]">
        <aside class="rounded-3xl border border-orange-100 bg-white p-6 shadow-sm">
          <div class="flex items-center gap-3">
            <span class="flex h-11 w-11 items-center justify-center rounded-2xl bg-[#FFE5EC] text-lg font-semibold text-[var(--accent)]">In</span>
            <div>
              <p class="text-base font-semibold text-ink">Invi8 Dashboard</p>
              <p class="text-xs text-muted">Vendor workspace</p>
            </div>
          </div>

          <nav class="mt-6 space-y-2 text-sm font-semibold">
            <RouterLink
              v-for="item in navItems"
              :key="item.to"
              :to="item.to"
              class="flex items-center justify-between rounded-xl px-3 py-3 transition"
              :class="isActive(item.to) ? 'bg-[#FFF3E5] text-ink' : 'text-muted hover:bg-gray-50'"
            >
              <span>{{ item.label }}</span>
              <span class="text-xs">→</span>
            </RouterLink>
          </nav>

          <div class="mt-8 rounded-2xl border border-orange-100 bg-[#FFF7EF] p-4 text-xs text-muted">
            <p class="text-sm font-semibold text-ink">Tip of the day</p>
            <p class="mt-2">Add package templates for repeatable proposals.</p>
          </div>
        </aside>

        <section class="space-y-6">
          <header class="rounded-3xl border border-gray-100 bg-white p-6 shadow-sm">
            <div class="flex flex-wrap items-center justify-between gap-4">
              <div>
                <p class="text-xs font-semibold uppercase tracking-[0.2em] text-muted">Welcome</p>
                <h1 class="mt-2 text-2xl font-semibold text-ink">{{ pageTitle }}</h1>
                <p class="mt-1 text-sm text-muted">Keep every event detail in sync.</p>
              </div>
              <div class="flex flex-wrap gap-3">
                <button class="rounded-full border border-gray-200 px-4 py-2 text-xs font-semibold text-ink transition hover:border-brand hover:text-brand">
                  Export
                </button>
                <button class="rounded-full bg-brand px-4 py-2 text-xs font-semibold text-white shadow-sm transition hover:bg-brandDark">
                  New package
                </button>
              </div>
            </div>
          </header>

          <RouterView />
        </section>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { RouterLink, RouterView, useRoute } from 'vue-router'

const route = useRoute()

const navItems = [
  { label: 'Dashboard', to: '/dashboard' },
  { label: 'Venues', to: '/dashboard/venues' },
  { label: 'Packages', to: '/dashboard/packages' },
  { label: 'Settings', to: '/dashboard/settings' }
]

const titleMap = {
  dashboard: 'Dashboard overview',
  'dashboard-venues': 'Venue pipeline',
  'dashboard-packages': 'Packages & pricing',
  'dashboard-settings': 'Workspace settings'
}

const pageTitle = computed(() => titleMap[route.name] || 'Dashboard')

const isActive = (path) => {
  if (path === '/dashboard') return route.path === '/dashboard'
  return route.path.startsWith(path)
}
</script>
